import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { AdminMultimediaImageGalleria } from '../models/admin-multimedia-image-galleria';

@Injectable()
export class AdminMultimediaGalleriaService {
  private readonly showSource$ = new Subject<AdminMultimediaImageGalleria>();

  public get show$(): Observable<AdminMultimediaImageGalleria> {
    return this.showSource$.asObservable();
  }

  public show(galeria: AdminMultimediaImageGalleria): void {
    this.showSource$.next(galeria);
  }
}
